/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// 这个文件太复杂了包含了，
// 好多的页面都是用的他渲染

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Time.css';
import Mind from '../Mind'
import Dbvalue from '../Dbvalue'
import History from '../History'
import DimensionCurve from '../DimensionCurve'
import Favorite from '../Favorite'
import Deepsea from '../Deepsea'
import Kol from '../Kol'
import Radar from '../Radar'
import moment from 'moment'
// import PropTypes from 'prop-types';
import loadingGif from './loading.gif'
import errPic from './errPic.gif'



// 对比图添加
import BattleDBvalue from '../BattleDBvalue'
import BattleHistory from '../BattleHistory'
import BattleRadar from '../BattleRadar'
import BattleCurve from  '../BattleCurve'
import BattleKOL from '../BattleKOL'
import BattleOpinion from '../BattleOpinion'
import BattleFavorite from '../BattleFavorite'


import SeleTime from '../SeleTime';


import MobileMind from '../MobileMind'

// import MockTestJson from './MockTestJson'

const seaQuery = {
  seaStartTime: null,
  seaEndTime: null,
  gradeState: false,
  newsState: false
}

const hasIndustry = industry => (industry ? `&areaIndustry=${industry}` : '')


class Time extends React.Component {

  constructor(props) {

    super(props);
    this.state = {
      isShowIndex: 0,
      timeItems: [],
      active: 6,
      checked:0,
      chartsJson:[],
      txtJson:[],
      error:null,
      id:'',
      mindList:[],
      loading:true,
      readyCharts:'',
      mindCharts:'',
      itemsState:[],

      startTime:null,
      endTime:null,

      seaQuery: seaQuery,
      seaState: false,

      // mindMobile
      mindMobile:false
    }
    // this.changeClass=this.changeClass.bind(this)
    this.showChart = this.showChart.bind(this)
    this.hightLightRender = this.hightLightRender.bind(this)
    this.getMindJson=this.getMindJson.bind(this)
    this.getDBvalueJson=this.getDBvalueJson.bind(this)
    this.getCharts=this.getCharts.bind(this)
    this.changeTime=this.changeTime.bind(this)
    this.loadingShow=this.loadingShow.bind(this)
    this.errorShow=this.errorShow.bind(this)
    this.getAnyTimeChartsJson=this.getAnyTimeChartsJson.bind(this)
    this.getSeaData=this.getSeaData.bind(this)
  }
  changeClass = (index) => {
    // console.log(index)
    this.setState({
      active: index
    })

  }

  componentWillMount() {
    // console.log(this.props)
    let arrItem = []
    if (moment().format('a') == 'pm') {
      for (let i = 7; i > 0; i--) {
        arrItem.push(moment().subtract(i, 'd').format('MM-DD'))
      }
    } else {
      for (let i = 8; i > 1; i--) {
        arrItem.push(moment().subtract(i, 'd').format('MM-DD'))
      }

    }
    this.setState({ timeItems: arrItem })
  }


  componentDidMount() {
    this.getCharts(this.props.isShow,this.props.items,this.props.time)
  }
  componentWillReceiveProps(nextProps) {
    if(this.brandEncodeList(nextProps.items)!=this.brandEncodeList(this.props.items)){
      this.getCharts(nextProps)
    }else if(nextProps.isShow!=this.props.isShow){
      this.getCharts(nextProps)
    }else if(nextProps.time!=this.props.time){
      this.getCharts(nextProps)
    }else if(nextProps.industry!=this.props.industry){
      this.getCharts(nextProps)
    }
  }



  shouldComponentUpdate(nextProps, nextState){
    let r=true
    if(nextProps.value!=this.props.value){
      r=false
    }
    return r  
  }
  loadingShow=()=>{
    return (
      <div className={s.loadingBox}>
        <i>
          <img src={loadingGif}/>
        </i>
      </div>
    )
  }
  errorShow=()=>{
    return(
      <div className={s.loadingBox}>
        <img src={errPic}/>
      </div>
    )
  }
  getCharts=(nextProps)=>{
    this.setState({
      seaState: false
    })
    const {isShow}=nextProps

    const aa=isShow?isShow:'心智占有率'  
    switch(aa){
      case('心智占有率'):
        this.getMindJson(nextProps)
        break;
      case('DB总值构成图'):
        this.getDBvalueJson(nextProps)
        break;
      case('历史曲线图'):
        this.getHistoryJson(nextProps)
        break;
      case('三维曲线图'):
        this.getCurveJson(nextProps)
        break;
      case('品牌三维图'):
        this.getRadarJson(nextProps)
        break;
      case('KOL参与图'):
        this.getKOLJson(nextProps)
        break;
      case('口碑舆情图'):
        this.getDeepseaJson(nextProps)
        break;
      case('受众好感图'):
        this.getFavortieJson(nextProps)
        break;
    }
  }
 showChart = () => {
    const { items, isShow } = this.props
    const {chartsJson,loading,readyCharts,mindCharts,txtJson, seaQuery}=this.state
    if(!loading){
      if (items.length!= 1) {
        // 多品牌比较
        if (isShow == '心智占有率'&&readyCharts=='心智占有率') {
          return (
            <div>         
              <span style={{padding:'5px 10px',border:'1px solid rgb(70, 16, 16)',borderRadius:'4px'}} onClick={()=>this.setState({mindMobile:!this.state.mindMobile})}>{!this.state.mindMobile?'打开':'关闭'}手机适配版</span>
              {this.state.mindMobile&&<MobileMind geo={this.props.geo} industry={this.props.industry} hightLight={this.state.checked} items={this.props.items} json={chartsJson} />}
              <Mind tableData={chartsJson} battleMind={txtJson}   items={this.props.items} json={chartsJson}  />
            </div>
          )
        } else if (isShow == 'DB总值构成图'&&readyCharts=='DB总值构成图') {
          return (
            <div>
              <BattleDBvalue  db={this.props.industry} items={this.props.items[0]} json={chartsJson} db={this.props.industry} />
            </div>
          )
        } else if (isShow == '历史曲线图'&&readyCharts=='历史曲线图') {
          return (
            <div>
              <BattleHistory   time={this.props.time}  json={chartsJson}  />
            </div>
          )
        } else if (isShow == '三维曲线图'&&readyCharts=='三维曲线图') {
          return (
            <div>
              <BattleCurve   time={this.props.time}  json={chartsJson}  />
            </div>
          )
        } else if (isShow == '品牌三维图'&&readyCharts=='品牌三维图') {
          return (
            <div>
              <BattleRadar  json={chartsJson}/>
            </div>
          )
        } else if (isShow == 'KOL参与图'&&readyCharts=='KOL参与图') {
          return (
            <div>
              <BattleKOL    json={chartsJson}  />
            </div>
          )
        } else if (isShow == '口碑舆情图'&&readyCharts=='口碑舆情图') {
          return (
            <div>
              <BattleOpinion   time={this.props.time}  json={chartsJson}  />
            </div>
          )
        } else if (isShow == '受众好感图'&&readyCharts=='受众好感图') {
          return (
            <div>
              <BattleFavorite  json={chartsJson}  />
            </div>
          )
        }
      }else if (items.length == 1) {
        // 单品牌比较
        if (isShow == '心智占有率'&&readyCharts=='心智占有率') {
          return (
            <div>
              <span style={{padding:'5px 10px',border:'1px solid rgb(70, 16, 16)',borderRadius:'4px'}} onClick={()=>this.setState({mindMobile:!this.state.mindMobile})}>{!this.state.mindMobile?'打开':'关闭'}手机适配版</span>
              {this.state.mindMobile&&<MobileMind geo={this.props.geo} industry={this.props.industry} hightLight={this.state.checked} items={this.props.items} json={mindCharts} />}
              <Mind tableData={chartsJson[0].tableData}  geo={this.props.geo} industry={this.props.industry} hightLight={this.state.checked} items={this.props.items} json={mindCharts} />
            </div>
          )
        } else if (isShow == 'DB总值构成图'&&readyCharts=='DB总值构成图') {
          return (
            <Dbvalue db={this.props.industry} items={this.props.items[0]} json={chartsJson} show={this.props.isShow} time={this.props.time} />
          )
        } else if (isShow == '历史曲线图'&&readyCharts=='历史曲线图') {
          return (
            <History items={this.props.items[0]} time={this.props.time} json={chartsJson}/>
          )
        } else if (isShow == '三维曲线图'&&readyCharts=='三维曲线图') {
          return (
            <DimensionCurve items={this.props.items[0]} json={chartsJson} time={this.props.time}/>
          )
        } else if (isShow == '品牌三维图'&&readyCharts=='品牌三维图') {
          return (
            <Radar items={this.props.items[0]} json={chartsJson}/>
          )
        } else if (isShow == 'KOL参与图'&&readyCharts=='KOL参与图') {
          return (
            <Kol items={this.props.items[0]} json={chartsJson} />
          )
        } else if (isShow == '口碑舆情图'&&readyCharts=='口碑舆情图') {
          return (
            <Deepsea
              items={this.props.items[0]}
              time={this.props.time}
              json={chartsJson}
              hasNewsState={seaQuery.newsState}
              seaQuery={this.state.seaQuery}
              seaState={this.state.seaState}
            />
          )
        } else if (isShow == '受众好感图'&&readyCharts=='受众好感图') {
          return (
            <Favorite items={this.props.items[0]}  json={chartsJson}/>
          )
        }
      }
    }
  }

  brandEncodeList=(items)=>{
    let list=[]
    for(let i=0;i<items.length;i++){
      let deUrl=decodeURIComponent(items[i].name)
      let enUrl=encodeURIComponent(deUrl)  
      list.push(enUrl)
    }
    let aa=list.join(',')
    return aa
  }
  getMindJson=({items,time,industry})=>{
    // console.log('心智即将更新',)
    // const {industry}=this.props
    this.setState({
      loading:true,
      error:false,
      readyCharts:'',
      mindList:[],
      checked:0,
    })
    let url
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    

    if(items!==undefined){

      if(items.length>1){
        url = `/digitalAssets/center/comparison/mind_share?brandNames=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;
      }else if(items.length===1){
        url = `/digitalAssets/center/mind_share?brandName=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;
      }
      fetch(url,myInit)
        .then(response => response.json())
        .then(data => {
          // console.log(data,'心智占有率单品牌')
          if(this.props.items.length==1&&this.props.isShow=='心智占有率'){
            let chartsList = data.chartsJson

            this.setState({
              chartsJson: chartsList,
              txtJson: chartsList,
              mindList:data.mindList,
              loading:false,
              readyCharts:'心智占有率',
              mindCharts:chartsList[0].items||[]
            })
          }else if(items.length>1&&this.props.isShow=='心智占有率'){
            this.setState({
              chartsJson:data.chartsJson,
              txtJson:data.highlight,
              loading:false,
              readyCharts:'心智占有率'
            })
          }
        
        })
        .catch(e => {
          console.log("Oops, error", e)
          this.setState({
              loading:false,
              error:e+url
          })
        })  
    } 
  
  
  }
  getDBvalueJson=({items,time,industry})=>{
    // const {industry}=this.props
    this.setState({
      loading:true,
      error:false,
      readyCharts:'',
      txtJson:[]
    })
    let url 
    if(items.length>1){
      url = `/digitalAssets/center/comparison/new/consistOfDB?brandNames=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;
    }else if(items.length==1){
      url = `/digitalAssets/center/consistOfDB?brandName=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`; 
    }

    const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
    };
    fetch(url,myInit)
      .then(response => response.json())
      .then(data => {
        // console.log(data,'db双品牌')
        if(this.props.isShow=='DB总值构成图'){
          this.setState({
                  chartsJson:data.chartsJson,
                  txtJson:data.highlight,
                  readyCharts:'DB总值构成图',
                  loading:false,
          })
        }
      
      })
      .catch(e => {
          console.log("Oops, error", e)
          this.setState({
              loading:false,
              error:true
          })
        })
      

    
    // console.log('执行')
  }
  getHistoryJson=({items,time,industry})=>{
      // console.log('拉取历史曲线图数据')
      // const url = `http://dbrank.net/digitalAssets/historyGraphs?brandId=1&statisDate=${this.state.timeItems[this.state.active]}`;
      // const {industry}=this.props
      this.setState({
        loading:true,
        error:false,
        readyCharts:''
      })
      let url
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
     };
      if(items.length>1){
        url = `/digitalAssets/center/comparison/new/historyGraphs?brandNames=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;
      }else if(items.length==1){
        url = `/digitalAssets/center/historyGraphs?brandName=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;  
      }
      
      fetch(url,myInit)
        .then(response => response.json())
        .then(data => {
          // console.log(data,'db双品牌')
          if(this.props.isShow=='历史曲线图'&&items.length==1){
            this.setState({
              chartsJson:data.historyList,
              txtJson:data.highlight,
              readyCharts:'历史曲线图',
              loading:false,
            })
          }else if(this.props.isShow=='历史曲线图'&&items.length>1){
            this.setState({
              chartsJson:data.chartsJson,
              txtJson:data.highLight,
              readyCharts:'历史曲线图',
              loading:false,
            })
          }
        
        })
        .catch(e => {
            console.log("Oops, error", e)
            this.setState({
                loading:false,
                error:true
            })
          })
      
        
      
  }

  getRadarJson=({items,time,industry})=>{
    // const url = `http://dbrank.net/digitalAssets/graphicModel?brandId=1&statisDate=${this.state.timeItems[this.state.active]}`;
    // console.log('拉取品牌三维图数据')
    // const {industry}=this.props
    this.setState({
      loading:true,
      error:false,
      readyCharts:''
    })
    let url
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    if(items.length>1){
      url = `/digitalAssets/center/comparison/new/graphicModel?brandNames=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;
    }else if(items.length==1){
      url = `/digitalAssets/center/graphicModel?brandName=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;  
    } 

    fetch(url,myInit)
      .then(response => response.json())
      .then(data => {
          // console.log(data,'雷达单')
          if(this.props.isShow=='品牌三维图'&&items.length==1){
            this.setState({
                    chartsJson:data.items,
                    txtJson:data.highlight,
                    readyCharts:'品牌三维图',
                    loading:false,
            })
          }else if(this.props.isShow=='品牌三维图'&&items.length>1){
            this.setState({
              chartsJson:data.chartsJson,
              txtJson:data.highLight,
              readyCharts:'品牌三维图',
              loading:false,
            })
          }
        
        })
      .catch(e => {
        console.log("Oops, error", e)
        this.setState({
            loading:false,
            error:true
        })
      })
      
  }

  getCurveJson=({items,time,industry})=>{
    // console.log('拉取三维曲线图数据')
    // const url = `http://dbrank.net/digitalAssets/historyGraphs?brandId=1&statisDate=${this.state.timeItems[this.state.active]}`;
    // const {industry}=this.props
    this.setState({
      loading:true,
      error:false,
      readyCharts:''
    })
    let url
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    if(items.length>1){
      url = `/digitalAssets/center/comparison/new/tripleGraphs?brandNames=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;
    }else if(items.length==1){
      url = `/digitalAssets/center/tripleGraphs?brandName=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;  

      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
    } 
    
      fetch(url,myInit)
        .then(response => response.json())
        .then(data => {
            // console.log(data,'三维曲线')
            if(this.props.isShow=='三维曲线图'){
            const txtJson=data.highlight?data.highlight:data.highLight
            
              this.setState({
                chartsJson:data.chartsJson,
                txtJson:txtJson,
                loading:false,
                readyCharts:'三维曲线图',
              })
            }
          
          })
        .catch(e => {
          console.log("Oops, error", e)
          this.setState({
              loading:false,
              error:true
          })
        })
  }
  getKOLJson=({items,time,industry})=>{
    // const {industry}=this.props
    this.setState({
      loading:true,
      error:false,
      readyCharts:''
    })
    let url 
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    if(items.length>1){
      
      url = `/digitalAssets/center/comparison/new/kol_participate?brandNames=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;
      
      fetch(url,myInit)
        .then(response => response.json())
        .then(data => {
            // console.log(data,'kol单')
            if(this.props.isShow=='KOL参与图'){

            this.setState({
              chartsJson:data.chartsJson,
              txtJson:data.highLight,
              readyCharts:'KOL参与图',
              loading:false,
            })
          }
        
        })
        .catch(e => {
          console.log("Oops, error", e)
          this.setState({
              loading:false,
              error:true
          })
        })
    }else if(items.length==1){
      

      url = `/digitalAssets/center/kol_participate?brandName=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;  
      
      fetch(url,myInit)
        .then(response => response.json())
        .then(data => {
          // console.log(data,'kol单')
          if(this.props.isShow=='KOL参与图'){
            this.setState({
              chartsJson: data.num_array,
              txtJson:data.highlight,
              readyCharts:'KOL参与图',
              loading:false,
            })
          }
        })
      .catch(e => {
        console.log("Oops, error", e)
        this.setState({
            loading:false,
            error:true
        })
      })
    }
  }
  getDeepseaJson=({items,time,industry})=>{
 
    // const {industry}=this.props
    this.setState({
      loading:true,
      error:false,
      readyCharts:''
    })
    let url
    if(items.length>1){
      url = `/digitalAssets/center/comparison/new/public_deep_sea?brandNames=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;
    }else if(items.length==1){
      // TODO
      // url = `/digitalAssets/center/public_deep_sea?brandName=${this.brandEncodeList(items)}&statisDate=${time}`;  
      url = `/digitalAssets/center/back/public_deep_sea?brandName=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;  
      
    }
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit)
        .then(response => response.json())
        .then(data => {
          // console.log(data,'口碑单')
          if(this.props.isShow=='口碑舆情图'){
            this.setState({
              chartsJson:data.chartsJson,
              txtJson:data.highlight,
              readyCharts:'口碑舆情图',
              loading:false,
            })
          }
        
        })
        .catch(e => {
        console.log("Oops, error", e)
          this.setState({
            loading:false,
            error:true
          })
        })
    
  }
  getFavortieJson=({items,time,industry})=>{
    // console.log('拉取受众好感图数据')
    // this.setState({loading:false,readyCharts:'受众好感图'})
    // const {industry}=this.props
    this.setState({
      loading:true,
      error:false,
      readyCharts:''
    })
    let url
    if(items.length>1){
      
      url = `/digitalAssets/center/comparison/new/public_favor?brandNames=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;
      
    }else if(items.length==1){
      url = `/digitalAssets/center/public_favor?brandName=${this.brandEncodeList(items)}&statisDate=${time}${hasIndustry(industry)}`;
    }
       const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit)
       .then(response => response.json())
       .then(data => {
            //  console.log(data,'受众好感图单')
            if(this.props.isShow=='受众好感图'){
                
            this.setState({
              // chartsJson:{"better": {"mua": 11160, "KOL": 1989}, "bad": {"mua": 7250, "KOL": 638}, "good": {"mua": 36580, "KOL": 3099}, "worse": {"mua": 1768, "KOL": 235}, "ne": {"mua": 15052, "KOL": 1749}},
              // chartsJson: {"better": {"mua": 1154, "KOL": 465}, "bad": {"mua": 1115, "KOL": 163}, "good": {"mua": 2165, "KOL": 547}, "worse": {"mua": 310, "KOL": 12}, "ne": {"mua": 1170, "KOL": 238}},
              chartsJson:data.chartsJson,
              txtJson:data.highlight,
              readyCharts:'受众好感图',
              loading:false,
            })
          }
        })
        .catch(e => {
          console.log("Oops, error", e)
          this.setState({
              loading:false,
              error:true
          })
        })
     
  }


    
  hightLightRender = () => {

    if(!this.state.loading){
      // console.log('摘要················')
      const { isShow, items } = this.props
      const {timeItems,active,chartsJson,txtJson,readyCharts,checked}=this.state

      let m, d
      if (this.props.time) {
        m = this.props.time.substring(5, 7)
        d = this.props.time.substring(8, 10)

      }
      // console.log(items,items.length)
      if (items.length == 1) {
        // 单品牌比较
        // console.log(items)
        if (isShow == '心智占有率'&&readyCharts=='心智占有率') {
          return (
            <div>
              <p>{m}月{d}日，{items[0].name}品牌的受众心智占有率为<span className={s.bold}>{txtJson[checked].highlight.mind}</span>，位居第<span className={s.bold}>{txtJson[checked].highlight.ranking}</span>名。</p>

            </div>
          )
        } else if (isShow == 'DB总值构成图'&&readyCharts=='DB总值构成图') {
          // console.log(txtJson.sort)
          let platform=txtJson.sort||['','','','']
          return (
            <div>
              <p>{m}月{d}日，{items[0].name}品牌在四大社交媒体平台上的DB值（数字品牌价值）为<span className={s.bold}>{ parseFloat(txtJson.db_total).toLocaleString()}</span>。</p>
              <p>四大平台DB值依次为：{platform[0]}平台>{platform[1]}平台>{platform[2]}平台>{platform[3]}平台。</p>
            </div>
          )
        } else if (isShow == '历史曲线图'&&readyCharts=='历史曲线图') {
          let max=txtJson.db_max_date||''
          let min=txtJson.db_min_date||''
          
          return (
            <div>
              <p>由{m}月{d}日回溯过去30天内，{items[0].name}品牌DB总值波峰日为{max.substring(5,7)}月{max.substring(8,10)}日，
                达到<span className={s.bold}>{parseFloat(txtJson.db_max).toLocaleString()}</span>；波谷日为{min.substring(5,7)}月{min.substring(8,10)}日，
                为<span className={s.bold}>{parseFloat(txtJson.db_min).toLocaleString()}</span>。</p>
            </div>
          )
        } else if (isShow == '品牌三维图'&&readyCharts=='品牌三维图') {
          return (
            <div>
              <p>{m}月{d}日，{items[0].name}品牌的总传播度是<span className={s.bold}>{txtJson.spread}%</span>，总参与度是<span className={s.bold}>{txtJson.participate}%</span>，总好感度是<span className={s.bold}>{txtJson.favorability}%</span>。</p>
            </div>
          )
        } else if (isShow == '三维曲线图'&&readyCharts=='三维曲线图') {
          let maxFa=txtJson.favorability_max_date||''
          let minFa=txtJson.favorability_min_date||''
          let maxSp=txtJson.spread_max_date||''
          let minSp=txtJson.spread_min_date||''
          let maxPa=txtJson.participate_max_date||''
          let minPa=txtJson.participate_min_date||''
          return (
            <div>
              <p>自{m}月{d}日起，过去30日内，</p>
              <p>{items[0].name}品牌传播度波峰日为{maxSp.substring(5,7)}月{maxSp.substring(8,10)}日，达到{txtJson.spread_max}%，波谷日为{minSp.substring(5,7)}月{minSp.substring(8,10)}日，为{txtJson.spread_min}%；</p>
              <p>参与度波峰日为{maxPa.substring(5,7)}月{maxPa.substring(8,10)}日，达到{txtJson.participate_max}%，波谷日为{minPa.substring(5,7)}月{minPa.substring(8,10)}日，为{txtJson.participate_min}%；</p>
              <p>好感度波峰日为{maxFa.substring(5,7)}月{maxFa.substring(8,10)}日，达到{txtJson.favorability_max}%，波谷日为{minFa.substring(5,7)}月{minFa.substring(8,10)}日，为{txtJson.favorability_min}%。</p>
            </div>
          )
        } else if (isShow == 'KOL参与图'&&readyCharts=='KOL参与图') {
          
          if(txtJson!=null){

            return (
              <div>
                <p>{m}月{d}日，{items[0].name}品牌获得KOL关注和参与度最高的平台是：<span className={s.bold}>{txtJson.max_plat}</span>平台。</p>
                <p>{chartsJson[4]==0?'在微信上，今日未有KOL卷入':`在微信上，参与讨论的认证账号有${chartsJson[4]}人次，卷入程度最高的${txtJson.wx_top5.length}个KOL是：${txtJson.wx_top5.map((i)=>'@'+i)}`}</p>
                <p>{chartsJson[0]+chartsJson[1]+chartsJson[2]==0?'在微博上，今日未有KOL卷入':`在微博上，参与讨论的金V认证账号有${chartsJson[0]}人次，橙V认证账号有${chartsJson[1]}人次，蓝V认证账号有${chartsJson[2]}人次，卷入程度最高的${txtJson.wb_top5.length||''}个KOL是：${txtJson.wb_top5.map((i)=>'@'+i)}`}</p>
                <p>{chartsJson[8]+chartsJson[9]==0?'在知乎上，今日未有KOL卷入':`在知乎上，参与讨论的优秀回答者有${chartsJson[8]}人次，认证回答者有${chartsJson[9]}人次，卷入程度最高的${txtJson.zh_top5.length||''}个KOL是：${txtJson.zh_top5.map((i)=>'@'+i)}`}</p>
                {!txtJson.jrtt&&<p>{chartsJson[6]+chartsJson[7]==0?'在今日头条上，今日未有KOL卷入':`在今日头条上，参与讨论的认证账号有${chartsJson[6]}人次，非认证账号有${chartsJson[7]}人次，卷入程度最高的${txtJson.tt_top5.length||''}个KOL是：${txtJson.tt_top5.map((i)=>'@'+i)}`}</p>}
                {txtJson.jrtt&&<p>{chartsJson[6]+chartsJson[7]==0?'在今日头条上，今日未有KOL卷入':`在今日头条上，参与讨论的认证账号有${txtJson.jrtt.tt_v_num}人次，非认证账号有${txtJson.jrtt.tt_mua_num}人次，卷入程度最高的${txtJson.jrtt_top5.length||''}个KOL是：${txtJson.jrtt_top5.map((i)=>'@'+i)}`}</p>}
                {txtJson.jrtt&&<p>{chartsJson[6]+chartsJson[7]==0?'在悟空问答上，今日未有KOL卷入':`在悟空问答上，参与讨论的认证账号有${txtJson.jrtt.wk_v_num}人次，非认证账号有${txtJson.jrtt.wk_mua_num}人次，卷入程度最高的${txtJson.wk_top5.length||''}个KOL是：${txtJson.wk_top5.map((i)=>'@'+i)}`}</p>}
              </div>
            )
          }
        
        } else if (isShow == '口碑舆情图'&&readyCharts=='口碑舆情图') {
          return (
            <div>
              <p>自{m}月{d}日起，过去7日内，{items[0].name}品牌的正面评价文章有<span className={s.bold}>{ parseFloat(txtJson.likeArt).toLocaleString()}</span>篇，占比<span className={s.bold}>{txtJson.likeScale}</span>；负面评价文章有<span className={s.bold}>{parseFloat(txtJson.badArc ).toLocaleString()}</span>篇，占比<span className={s.bold}>{txtJson.badScale}</span>。</p>
              <p>受众对{items[0].name}品牌好感度最高的平台是<span className={s.bold}>{txtJson.likePlat}</span>平台；口碑最差的是<span className={s.bold}>{txtJson.badPlat}</span>平台。</p>
              {txtJson.allScale&&<p>{`全网推荐均值：${txtJson.allScale.better}，全网好感均值：${txtJson.allScale.good}， 全网中立均值：${txtJson.allScale.ne}， 全网差评均值：${txtJson.allScale.bad}， 全网反感均值：${txtJson.allScale.worse};`}</p>}
            </div>
          )
        } else if (isShow == '受众好感图'&&readyCharts=='受众好感图') {
          return (
            <div>
              <p>{m}月{d}日，{items[0].name}品牌的受众整体情感倾向是：顺意群体占<span className={s.bold}>{txtJson.shunyi_per}</span>，中立群体占<span className={s.bold}>{txtJson.zhongli_per}</span>，逆意群体占<span className={s.bold}>{txtJson.niyi_per}</span>。</p>
              <p>对{items[0].name}品牌持好感态度的人群较多集中在<span className={s.bold}>{txtJson.platform}</span>平台。</p>
              <p>{items[0].name}品牌的{txtJson.like?'好感':'差评'}阵营中KOL的分布密度较高。</p>
              {txtJson.allScale&&<p>{`全网顺意均值：${txtJson.allScale.better}， 全网中立均值：${txtJson.allScale.ne}，  全网逆意均值：${txtJson.allScale.worse};`}</p>}
              
            </div>
          )
        }
      } else if (items.length !=1 ) {
        
          let o=items.length
  
          // 多品牌比较
          if (isShow == '心智占有率'&&readyCharts=='心智占有率') {
            let initTxtBox=[]
            for(let i=0;i<o;i++){
              let initTxt=<span key={i}>{items[i].name}品牌的受众心智占有率为<span className={s.bold}>{txtJson[i]}</span>；</span>
              initTxtBox.push(initTxt)
  
            }
            let initTxtList=[<p key='pKeyKEY' >{m}月{d}日，{initTxtBox}</p>]
            
            return initTxtList
  
            
          } else if (isShow == 'DB总值构成图'&&readyCharts=='DB总值构成图') {
            let db=txtJson.db_totals||['','','']
            let platform=txtJson.sortList||['','','','']
  
            let [initTxtList,rankList]=[[],[]]
            
            
            for(let i=0;i<o;i++){
              let initTxt=<span key={i}>{db[i].brandName}品牌在四大社交媒体平台上的DB值（数字品牌价值）为<span className={s.bold}>{db[i].db}</span>{db[i+1]?';':'。'}</span>
              let rank=<span key={i}>{platform[i]}品牌数字品牌价值{platform[i+1]?'>':null}</span>
              initTxtList.push(initTxt)
              rankList.push(rank)
              // doms.push(initTxt)
            }
            let doms=[<p key='s'>{m}月{d}日,{initTxtList}</p>]
            
            doms.push(rankList)
  
            
            return doms
            
            // return (
            //   <div>
            //     <p>{m}月{d}日，{items[0].name}品牌在四大社交媒体平台上的DB值（数字品牌价值）为<span className={s.bold}>{db[0]}</span>；{items[1].name}品牌在四大社交媒体平台上的DB值（数字品牌价值）为<span className={s.bold}>{db[1]}</span>。</p>
            //     <p>{platform[0]}品牌数字品牌价值>{platform[1]}品牌数字品牌价值</p>
            //   </div>
            // )
          } else if (isShow == '历史曲线图'&&readyCharts=='历史曲线图') {
          
  
            let initTxtList=[]
  
            for(let i=0;i<o;i++){
              let max=txtJson[i].db_max_date
              let min=txtJson[i].db_min_date
  
              let initTxt=<p>
                由{m}月{d}日回溯过去30天内，{items[i].name}品牌DB总值波峰日为{max.substring(5,7)}月{max.substring(8,10)}日，
                达到<span className={s.bold}>{txtJson[i].db_max}</span>；
                波谷日为{min.substring(5,7)}月{min.substring(8,10)}日，
                为<span className={s.bold}>{txtJson[i].db_min}</span>。
              </p>
  
              initTxtList.push(initTxt)
            }
            return initTxtList
          } else if (isShow == '品牌三维图'&&readyCharts=='品牌三维图') {
  
            let initTxtList=[]
            for(let i=0;i<o;i++){
              let initTxt= <p>{m}月{d}日，{items[i].name}品牌的总传播度是<span className={s.bold}>{txtJson[i].spread}%</span>，总参与度是<span className={s.bold}>{txtJson[i].participate}%</span>，总好感度是<span className={s.bold}>{txtJson[i].favorability}%</span>。</p>
              initTxtList.push(initTxt)
            }
            return initTxtList
            
            
          } else if (isShow == '三维曲线图'&&readyCharts=='三维曲线图') {
            
  
  
  
            let [initTxtList,doms]=[[],[<p>自{m}月{d}日起，过去30日内，</p>]]
            for(let i=0;i<o;i++){
              let maxFa=txtJson[i].favorability_max_date||''
              let minFa=txtJson[i].favorability_min_date||''
              let maxSp=txtJson[i].spread_max_date||''
              let minSp=txtJson[i].spread_min_date||''
              let maxPa=txtJson[i].participate_max_date||''
              let minPa=txtJson[i].participate_min_date||''
  
  
              let initTxt=<p>{items[i].name}品牌传播度波峰日为{maxSp.substring(5,7)}月{maxSp.substring(8,10)}日，达到{txtJson[i].spread_max}%，波谷日为{minSp.substring(5,7)}月{minSp.substring(8,10)}日，为{txtJson[i].spread_min}%；参与度波峰日为{maxPa.substring(5,7)}月{maxPa.substring(8,10)}日，达到{txtJson[i].participate_max}%，波谷日为{minPa.substring(5,7)}月{minPa.substring(8,10)}日，为{txtJson[i].participate_min}%；好感度波峰日为{maxFa.substring(5,7)}月{maxFa.substring(8,10)}日，达到{txtJson[i].favorability_max}%，波谷日为{minFa.substring(5,7)}月{minFa.substring(8,10)}日，为{txtJson[i].favorability_min}%。</p>
              initTxtList.push(initTxt)  
            }
  
            return initTxtList
          
            
          } else if (isShow == 'KOL参与图'&&readyCharts=='KOL参与图') {
  
  
            let initTxtList=[]
            for(let i=0;i<o;i++){
              let initTxt=<p key={i}>{m}月{d}日，{items[i].name}品牌获得KOL关注和参与度最高的平台是：<span className={s.bold}>{txtJson[i]}</span>平台。</p>
  
              initTxtList.push(initTxt)
  
            }
            return initTxtList
  
            
          } else if (isShow == '口碑舆情图'&&readyCharts=='口碑舆情图') {
  
            let initTxtList=[]
            for(let i=0;i<o;i++){
              let initTxt=<p>自{m}月{d}日起，过去7日内，{items[i].name}品牌的正面评价文章有<span className={s.bold}>{txtJson[i].likeArt}</span>篇，占比<span className={s.bold}>{txtJson[i].likeScale}</span>；负面评价文章有<span className={s.bold}>{txtJson[i].badArc}</span>篇，占比<span className={s.bold}>{txtJson[i].badScale}</span>。</p>
              initTxtList.push(initTxt)
            }
            return initTxtList
  
            
          } else if (isShow == '受众好感图'&&readyCharts=='受众好感图') {
  
            let initTxtList=[]
            for(let i=0;i<o;i++){
              let initTxt=<p key={i}>{m}月{d}日，{items[i].name}品牌的受众整体情感倾向是：顺意群体占<span className={s.bold}>{txtJson[i].shunyi_per}</span>，中意群体占<span className={s.bold}>{txtJson[i].zhongli_per}</span>，逆意群体占<span className={s.bold}>{txtJson[i].niyi_per}</span>。</p>
              initTxtList.push(initTxt)
            }
            return initTxtList
            
          }
        }
      }

  }

  changeTime=(index)=>{
    const aa=this.state.timeItems[index]
    this.props.getArtTime(`${moment(aa,'MM-DD').subtract(6,'days').format('YYYY-MM-DD')},${moment(aa,'MM-DD').format('YYYY-MM-DD')}`)
    this.setState({ active: index })
  }

  getAnyTimeChartsJson=()=>{

    const {items,time,isShow, industry}=this.props
    const {startTime,endTime}=this.state
    this.setState({
      loading:true,
      error:false,
      readyCharts:''
    })
    let url 
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    if(items.length>1&&isShow=='KOL参与图'){
      // url = `/digitalAssets/center/comparison/new/kol_participate?brandNames=${this.brandEncodeList(items)}&statisDate=${time}`;
      url = `/digitalAssets/center/comparison/new/kol_participate_seg?brandNames=${this.brandEncodeList(items)}&startDate=${startTime}&statisDate=${endTime}${hasIndustry(industry)}`;
    }else if(items.length==1&&isShow=='KOL参与图'){
      // url = `/digitalAssets/center/kol_participate?brandName=${this.brandEncodeList(items)}&statisDate=${time}`;  
      url = `/digitalAssets/center/kol_participate_seg?brandName=${this.brandEncodeList(items)}&startDate=${startTime}&statisDate=${endTime}${hasIndustry(industry)}`
      
    }else if(items.length==1&&isShow=='受众好感图'){
      url =`/digitalAssets/center/public_favor_seg?brandName=${this.brandEncodeList(items)}&startDate=${startTime}&statisDate=${endTime}${hasIndustry(industry)}`
    }else if(items.length>1&&isShow=='受众好感图'){
      url = `/digitalAssets/center/comparison/new/public_favor_seg?brandNames=${this.brandEncodeList(items)}&startDate=${startTime}&statisDate=${endTime}${hasIndustry(industry)}`;
    }
    
      fetch(url,myInit)
      .then(response => response.json())
      .then(data => {
          // console.log(data,'kol单')
          if(this.props.isShow=='KOL参与图'){
            let chartsJson,highLight
            if(items.length>1){
              chartsJson=data.chartsJson
              highLight=data.highLight
            }else{
              chartsJson=data.num_array
              highLight=data.highlight
            }
            this.setState({
              chartsJson:chartsJson,
              txtJson:highLight,
              readyCharts:'KOL参与图',
              loading:false,
            })
            return
          }

          if(this.props.isShow=='受众好感图'){
            
            this.setState({
              chartsJson:data.chartsJson,
              txtJson:data.highlight,
              readyCharts:'受众好感图',
              loading:false,
            })
            return
          }
        
        })
      .catch(e => {
        console.log("Oops, error", e)
        this.setState({
            loading:false,
            error:true
        })
      })
  }

  getSeaData () {
    const {items,time,industry} = this.props
     this.setState({
      loading:true,
      error:false,
      readyCharts:''
    })
    let _time = (new Date().getHours() >= 11) ? time : moment(time).subtract(1, 'day');
    let url
    if(items.length>1){
      url = `/digitalAssets/center/comparison/new/public_deep_sea?brandNames=${this.brandEncodeList(items)}&statisDate=${_time}${hasIndustry(industry)}`;
    }else if(items.length==1){
      // TODO
      // url = `/digitalAssets/center/public_deep_sea?brandName=${this.brandEncodeList(items)}&statisDate=${time}`;  
      url = `/digitalAssets/center/back/public_deep_sea?brandName=${this.brandEncodeList(items)}&statisDate=${seaQuery.seaEndTime}&startDate=${seaQuery.seaStartTime}&grade=${seaQuery.gradeState}&news=${seaQuery.newsState}${hasIndustry(industry)}`;  
    }
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit)
        .then(response => response.json())
        .then(data => {
          if(this.props.isShow=='口碑舆情图'){
            // console.log(MockTestJson);
            // const data = require('./caculation.json')
            // debugger

          this.setState({
            seaState: true,
            // chartsJson: MockTestJson.chartsJson,
            chartsJson: data.chartsJson,
            txtJson:data.highlight,
            readyCharts:'口碑舆情图',
            loading:false,
          })
        }
        
        })
        .catch(e => {
          this.setState({
              loading:false,
              error:true
          })
        })
  }

  render() {
    // console.log(this.props.items, this.state.items[this.state.active])
    // this.getTimeList()
    // console.log('刷新了'+this.props.isShow,this.state.chartsJson)
    const {loading,readyCharts,error,mindList,startTime,endTime}=this.state
    const {isShow}=this.props
    // this.getCharts()
    // console.log('渲染了time组件',this.props.industry)
    // console.log(this.props.time,'TIME模块接受到的数据',)
    // console.log(this.state.chartsJson)
    if(this.state.chartsJson){

      return (
        <div className={s.root}>
          <div className={readyCharts== '心智占有率'&&this.props.items.length==1&&!loading ? s.selectedItem : s.hide}>
            {mindList&&mindList.length>0?
              <form>
                <label htmlFor="" className={s.select}>请选择</label>
                {this.state.mindList.map((item,index)=>(
                  <label htmlFor="" className={s.radioItem} key={item}> 
                    <input name={item} type='radio' checked={this.state.checked==index?'checked':''} className={s.checkItem} 
                      onChange={()=>{
                        this.setState({
                          checked:index,
                          mindCharts:this.state.chartsJson[index].items
                        })}}
                    /> {item}</label>
                ))}
              </form>
              :null}
            </div>
            
            {(isShow=='KOL参与图'||isShow=='受众好感图')
            &&<div className={s.anySeletTime}>
                <div className={s.anyTimeBox}>
                  <SeleTime canOnchangeDate={true} topTime={(time)=>this.setState({startTime:time})} />   
                </div>
                至
                <div className={s.anyTimeBox}>
                   <SeleTime canOnchangeDate={true} topTime={(time)=>this.setState({endTime:time})} />
                </div>
                <span className={s.readyBtn} onClick={this.getAnyTimeChartsJson}>选好时间了！</span>
              </div>
            }
            {/* 口碑舆情图 */}
            {(isShow=='口碑舆情图')
            &&<div style={{
              display: 'flex',
              height: '30px'
            }}>
              <SeleTime canOnchangeDate={true} topTime={(time)=>seaQuery.seaStartTime = time} /> 
              <span>至</span>
              <SeleTime canOnchangeDate={true} topTime={(time)=>seaQuery.seaEndTime = time} />

              <label htmlFor="">是否分级：</label>
              <select onChange={ e=> seaQuery.gradeState = e.target.value !== 'false'}>
                <option value="false">分级</option>
                <option value="true">不分级</option>
              </select>
    
              <label htmlFor="">新闻百家号</label>
              <select onChange={e=> seaQuery.newsState= e.target.value !== 'false'}>
                <option value="false">否</option>
                <option value="true">是</option>
              </select>
              <span className={s.readyBtn} onClick={this.getSeaData}>选好时间了！</span>
            </div>
            }
          {/* {error?this.errorShow():null} */}
          {loading ? this.loadingShow() : this.showChart()}
          
          <div className={s.picInt}>
            <span className={s.h2Tit}>提要 </span>
            <span className={s.int}>Highlights</span>
            {this.hightLightRender()}
          </div>
        </div>
      )
    }else{
      return <div></div>
    }
  }
}

export default withStyles(s)(Time);








// WEBPACK FOOTER //
// src/components/Time/Time.js